import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GenerateDataKeyPairWithoutPlaintext$ } from "../schemas/schemas_0";
export { $Command };
export class GenerateDataKeyPairWithoutPlaintextCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "GenerateDataKeyPairWithoutPlaintext", {})
    .n("KMSClient", "GenerateDataKeyPairWithoutPlaintextCommand")
    .sc(GenerateDataKeyPairWithoutPlaintext$)
    .build() {
}
